import styled, { css } from 'styled-components';
import { typographyAttributes } from '../style-helpers/index.browser.esm.js';
import { getThemeColor, calcRem, screenSizes } from '@shipt/design-system-themes';

const Display = styled.p.attrs(typographyAttributes).withConfig({
    displayName: "index.browser__Display",
    componentId: "sc-e1eb6702-0"
})(({ align, concept = 'base', feedbackType, size = 'lg', surface = 'default', theme, variant = 'primary', weight = 'semibold' })=>{
    const fontGetter = (key, breakpoint = 'mobile')=>theme.font.dynamic.display[weight][breakpoint][size][key];
    const textColor = getThemeColor({
        theme,
        concept,
        variant,
        surface,
        feedbackType
    });
    return css([
        `color:`,
        `;font-family:`,
        `;font-size:`,
        `rem;font-style:`,
        `;font-weight:`,
        `;letter-spacing:`,
        `rem;line-height:`,
        `;margin:0;text-align:`,
        `;text-decoration:`,
        `;text-decoration-color:`,
        `;text-transform:`,
        `;& > a{color:inherit;}@media `,
        `{font-size:`,
        `rem;line-height:`,
        `;letter-spacing:`,
        `rem;}@media `,
        `{font-size:`,
        `rem;line-height:`,
        `;letter-spacing:`,
        `rem;}`
    ], textColor, fontGetter('fontFamily'), calcRem(fontGetter('fontSize')), fontGetter('fontStyle'), fontGetter('fontWeight'), calcRem(fontGetter('letterSpacing')), fontGetter('lineHeight'), align || null, fontGetter('textDecoration'), textColor, fontGetter('textCase'), screenSizes.tablet, calcRem(fontGetter('fontSize', 'tablet')), fontGetter('lineHeight', 'tablet'), calcRem(fontGetter('letterSpacing', 'tablet')), screenSizes.smDesktop, calcRem(fontGetter('fontSize', 'desktop')), fontGetter('lineHeight', 'desktop'), calcRem(fontGetter('letterSpacing', 'desktop')));
});

export { Display };
